import { useCallback } from "react";
import { Country } from "@lookiero/sty-psp-locale";
import { Segment } from "@lookiero/sty-psp-segment";
import { TrackingEventCategory, useEmitUserEvent } from "@lookiero/sty-psp-tracking";
import { Tradename } from "@lookiero/sty-sp-tradename";
import { PromocodeInvalidTrackingEvent, PromocodeValidTrackingEvent, TrackingEventName } from "./tracking";

interface TrackPromocodeFunctionArgs {
  readonly promocode: string;
}

interface TrackPromocodeFunction {
  (args: TrackPromocodeFunctionArgs): void;
}

interface UseTrackPromocodeFunctionArgs {
  readonly event: TrackingEventName.PROMOCODE_INVALID | TrackingEventName.PROMOCODE_VALID;
  readonly country: Country;
  readonly segment: Segment;
  readonly userId: string;
  readonly tradename: Tradename;
}

interface UseTrackPromocodeFunction {
  (agrs: UseTrackPromocodeFunctionArgs): TrackPromocodeFunction;
}

const useTrackPromocode: UseTrackPromocodeFunction = ({ event, country, segment, tradename, userId }) => {
  const emitUserEvent = useEmitUserEvent<PromocodeInvalidTrackingEvent | PromocodeValidTrackingEvent>();

  const trackPromocode: TrackPromocodeFunction = useCallback(
    ({ promocode }) => {
      emitUserEvent({
        event,
        eventCategory: TrackingEventCategory.ECOMMERCE,
        store: country,
        section: "Shop",
        segment,
        tradename,
        userId,
        userUuid: userId,
        coupon: promocode,
      });
    },
    [country, emitUserEvent, event, segment, tradename, userId],
  );

  return trackPromocode;
};

export { useTrackPromocode };
